import { render, staticRenderFns } from "./ApprTemp4.vue?vue&type=template&id=74bc695c&scoped=true&"
import script from "./ApprTemp4.vue?vue&type=script&lang=js&"
export * from "./ApprTemp4.vue?vue&type=script&lang=js&"
import style0 from "./ApprTemp4.vue?vue&type=style&index=0&id=74bc695c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc695c",
  null
  
)

export default component.exports